export const reduceModifierBreakpoints = (modifierObject, mappingFunction) => {
    return Object.entries(modifierObject).reduce((acc, [key, value]) => {
        const breakpoint = key;
        acc[breakpoint] = mappingFunction(value);
        return acc;
    }, {});
};
//# sourceMappingURL=reduce-modifier-breakpoints.js.map